import {Component, OnInit} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../auth/auth.service';
import {GetService} from '../../core/get.service';
import {AppMemoryService} from '../../core/app-memory.service';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-locate-unauth',
    templateUrl: './locate-unauth.component.html',
    styleUrls: ['./locate-unauth.component.less']
})
export class LocateUnauthComponent implements OnInit {

    public availableCountries = [];

    // page the user was heading for before being sent here
    public nextPage = 'login';

    constructor(public router: Router,
                public appMemory: AppMemoryService,
                public authService: AuthService,
                public getService: GetService,
                public route: ActivatedRoute) {

        const next = this.route.snapshot.queryParams['next'];
        if (next === 'sign' || next === 'forgot') {
            this.nextPage = next;
        }

        if (this.authService.isLocated) {
            this.router.navigateByUrl('/' + this.nextPage);
        }
    }

    ngOnInit() {
        Object.keys(environment.availableCountries).forEach(country => {
            this.availableCountries.push({
                country: country,
            })
        });
    }


    public chooseCountry(choose) {
        this.authService.setLocated();
        // ?located=1 carries the choice to the target domain, which keeps its own storage
        window.location.href = environment.availableCountries[choose] + '/' + this.nextPage + '?located=1';
    }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/locate-unauth/locate-unauth.component.ts